import { render, staticRenderFns } from "./DeclinedApprovalProduct.vue?vue&type=template&id=0ddcc281&scoped=true&"
import script from "./DeclinedApprovalProduct.vue?vue&type=script&lang=js&"
export * from "./DeclinedApprovalProduct.vue?vue&type=script&lang=js&"
import style0 from "./DeclinedApprovalProduct.vue?vue&type=style&index=0&id=0ddcc281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddcc281",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
